import React, { useCallback, useEffect } from 'react';
import Form from 'screens/shared/form';
import { Button, debounce } from '@mui/material';
import { Refresh } from '@mui/icons-material';
import { rollRelativeTimeRange } from 'utils/time';
import { _t } from 'utils';

export default ({ onChange, model, onRefresh = () => {} }) => {
  const debouncedChange = useCallback(debounce(onChange, 300), []);

  useEffect(() => {
    const intervalCleaner = setInterval(() => {
      onChange({ ...model, range: rollRelativeTimeRange(model.range) });
    }, 60 * 1000);

    return () => {
      clearInterval(intervalCleaner);
    };
  }, [onChange, model]);

  const timeRangeFields = [{
    name: 'range',
    title: _t('Range'),
    type: 'time-range',
  }];

  // const refreshRateFields = [{
  //   name: 'refreshInterval',
  //   title: _t('Refresh every'),
  //   type: 'dropdown',
  //   options: [[1, 'Off'], [5000, '5s'], [30000, '30s'], [60000, '1m'], [5 * 60 * 1000, '5m'], [15 * 60 * 1000, '15m']],
  // }];

  return (
    <div className="form-container metricsArea" style={{ width: '100%' }}>
      {/* <div className="refresher"> */}
      <div>
        <Button
          variant="outlined"
          size="small"
          color="primary"
          onClick={onRefresh}
        >
          <Refresh />
        </Button>
        {/* <Form
          isCancel={false}
          fields={refreshRateFields}
          fieldsValues={{ refreshInterval: model.refreshInterval }}
          onChange={debouncedChange}
        /> */}
      </div>

      <Form
        isCancel={false}
        fields={timeRangeFields}
        fieldsValues={{ range: model.range }}
        onChange={debouncedChange}
        style={{
          flexGrow: 1,
          marginLeft: 20,
        }}
      />

    </div>
  );
};
